package de.ohhhmhhh.frontend.admin.ui.screens.text.edit

import de.ohhhmhhh.backend.models.model.text.StaticTextTypeEntity
import de.ohhhmhhh.frontend.admin.ui.components.inputs.SelectItem

data class TextEditState(
    val revisions: List<SelectItem> = emptyList(),
    val revision: String? = null,
    val savable: Boolean = true,
    val saved: String? = null,
    val id: String? = null,
    val title: String? = null,
    val content: String? = null,
    val version: String? = null,
    val type: StaticTextTypeEntity? = null
)
